import { createFileRoute } from "@tanstack/react-router";
import OwnerMetricsPage from "@/pages/OwnerMetricsPage";

export const Route = createFileRoute("/_owner/owner/metrics")({
  component: OwnerMetricsPage,
});
